import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../services/loading.service';
import { LoadingOverlayComponent } from '../loading-overlay/loading-overlay.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-global-loading',
  standalone: true,
  imports: [CommonModule, LoadingOverlayComponent],
  templateUrl: './global-loading.component.html',
  styleUrls: ['./global-loading.component.css']
})
export class GlobalLoadingComponent implements OnInit, OnDestroy {
  isLoading = false;
  loadingMessage = 'Carregando...';
  
  private loadingSubscription?: Subscription;
  private messageSubscription?: Subscription;

  constructor(
    private loadingService: LoadingService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    console.log('🔧 GlobalLoadingComponent: Inicializando...');
    
    // Initialize with translated default message
    this.loadingMessage = this.translate.instant('loading.default');
    
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(
      loading => {
        console.log('🔄 GlobalLoadingComponent: Estado de loading alterado:', loading);
        this.isLoading = loading;
      }
    );
    
    this.messageSubscription = this.loadingService.loadingMessage$.subscribe(
      message => {
        console.log('🔄 GlobalLoadingComponent: Mensagem alterada:', message);
        this.loadingMessage = message;
      }
    );
  }

  ngOnDestroy() {
    this.loadingSubscription?.unsubscribe();
    this.messageSubscription?.unsubscribe();
  }
}


